<template>
    <qc-container title="编辑轮播图" show-return show-divider>
      <el-form ref="ruleForm" :model="addRow"  label-width="120px">
        <form-item-rule class="row" label="名称" prop="name">
          <el-input class="w300" v-model="addRow.name" placeholder="请输入名称"></el-input>
        </form-item-rule>
        <el-form-item class="row" label="图片" prop="pic">
          <upload :type="1" v-model="addRow.pic" :width="702" :height="280"></upload>
        </el-form-item>
        <el-form-item class="row" label="链接地址" prop="url">
          <input-url v-model="addRow.url"></input-url>
        </el-form-item>
        <el-form-item class="row" label="排序" prop="sort">
          <el-input-number :min="0" class="w200" v-model="addRow.sort" placeholder="请输入排序"></el-input-number>
        </el-form-item>
        <el-form-item class="row" label="是否上架" prop="status">
          <el-switch v-model="addRow.status" :active-value="1" :inactive-value="0" active-color="#13ce66"
                     inactive-color="#ff4949"></el-switch>
        </el-form-item>
        <el-form-item class="row" label="展示位置" prop="status">
          <simple-dict v-model="addRow.type" :init-options="options"></simple-dict>
        </el-form-item>
        <el-form-item class="tc mr50">
          <el-button class="f14" @click="returnLast">返回</el-button>
          <el-button class="f14" type="primary" @click="submitForm('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </qc-container>
</template>

<script>

import QcContainer from "@/components/el/layout/qc-container.vue";
import FormItemRule from "@/components/el/form-item-rule.vue";
import SimpleDict from "@/components/dict/SimpleDict.vue";
import Upload from "@/components/upload/upload.vue";
import InputUrl from "@view/content/components/InputUrl.vue";

export default {
  name: "banner-add",
  components: {InputUrl, Upload, SimpleDict, FormItemRule, QcContainer},
  data() {
    return {
      addRow: {id: '', name: '', pic: '', url: '', sort: '', status: 0},
      options:[{label:"商城",value:0},{label:"租售",value:1}]
    }
  },
  mixins: [tableBase],
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.simplePost("/api/mgr/business/shop/banner/addOrUpdate", this.addRow, () => {
            this.returnLast();
          });
        }
      });
    },
    getDetail() {
      this.simpleGet( "/api/mgr/business/shop/banner/detail", {id: this.addRow.id}, result => {
        this.addRow = result.data;
      });
    },
  },
  mounted() {
    if (this.$route.query && this.$route.query.id) {
      this.addRow.id = this.$route.query.id;
      this.getDetail();
    }
  }
}
</script>


<style lang="less" scoped>
</style>
